export default {
    date: {
        label: 'Data',
        field: 'date',
        type: 'general',
        align: 'left',
        customWidth: 130,
        fixed: false,
        render: true,
    },
    hour: {
        label: 'Hora',
        field: 'hour',
        type: 'general',
        align: 'left',
        customWidth: 100,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    branch: {
        label: 'Loja',
        field: 'branch',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
    },
    cdLm: {
        label: 'LM',
        field: 'cdLm',
        type: 'general',
        align: 'left',
        customWidth: 120,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    lmDesc: {
        label: 'Descrição',
        field: 'lmDesc',
        type: 'general',
        align: 'left',
        customWidth: 300,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    section: {
        label: 'Seção',
        field: 'section',
        type: 'general',
        align: 'left',
        customWidth: 150,
        fixed: false,
        render: true,
        disableOrder: true,
    },
};
